import { NumericInput } from '@interstate/components/NumericInput';

import { TextInput } from '@interstate/components/TextInput';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';
import { ActionWithErrorBadge } from '@makemydeal/dr-dash-components';
import React from 'react';

import type { ReadOnlyInputActionOptions } from './useReadOnlyInputAction';
import { useReadOnlyInputAction } from './useReadOnlyInputAction';

interface ReadOnlyInputProps extends ReadOnlyInputActionOptions {
    label: string;
    inputValue?: string;
    'data-testId'?: string;
}

const ReadOnlyInput = (props: ReadOnlyInputProps) => {
    const { label, inputValue, tab, type = 'amount', onClick } = props;
    const dateTestId = props['data-testId'] || label;

    const { entityName, isClickable, activate: handleClick } = useReadOnlyInputAction({ tab, type, onClick });
    const shouldShowErrorBadge = !!entityName;

    const handleLabelKeyDown = (e: React.KeyboardEvent) => {
        if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            handleClick();
        }
    };

    const handleInputClick = () => {
        if (isClickable) {
            handleClick();
        }
    };

    const handleInputKeyDown = (e: React.KeyboardEvent) => {
        if (isClickable && e.key === 'Enter') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <>
            <label
                className="base-deal-activity-control-custom-label"
                data-testid={`${dateTestId}-label`}
                style={
                    isClickable
                        ? {
                              width: 'fit-content'
                          }
                        : {}
                }
                onClick={handleClick}
                onKeyDown={handleLabelKeyDown}
                {...(isClickable && { tabIndex: 0, role: 'button' })}
            >
                {shouldShowErrorBadge ? (
                    <ActionWithErrorBadge entityName={entityName} xOffset="-2px" yOffset="1px">
                        {label}
                    </ActionWithErrorBadge>
                ) : (
                    label
                )}
                {isClickable && <ChevronRightIcon fontSize={10} />}
            </label>
            {type === 'amount' ? (
                <div onClick={handleInputClick} onKeyDown={handleInputKeyDown} style={{ cursor: 'pointer' }}>
                    <NumericInput
                        className="read-only-input"
                        size="sm"
                        sx={{ lineHeight: '31px', pointerEvents: 'none' }}
                        displayLabel={false}
                        name={dateTestId}
                        data-testid={dateTestId}
                        readOnly={true}
                        value={inputValue}
                        inputPrefix={'$'}
                        allowDecimal={true}
                    />
                </div>
            ) : (
                <div
                    onClick={handleInputClick}
                    onKeyDown={handleInputKeyDown}
                    style={isClickable ? { cursor: 'pointer' } : undefined}
                >
                    <TextInput
                        className="read-only-input"
                        size="sm"
                        sx={{ lineHeight: '31px', ...(isClickable && { pointerEvents: 'none' }) }}
                        displayLabel={false}
                        name={dateTestId}
                        data-testid={dateTestId}
                        readOnly={true}
                        value={inputValue}
                    />
                </div>
            )}
        </>
    );
};

export default ReadOnlyInput;
